import {useContext} from 'react';
import {Form, Spin} from "antd";
import ReactQuill from "react-quill";
import {CatalogContext} from "../../../../providers/CatalogProvider";

const ProductDescriptionItem = () => {
    const {product, isLoadingProduct, setProduct} = useContext(CatalogContext)

    return (
        <Form.Item label="Description">
            {
                isLoadingProduct
                    ? <Spin size='small'/>
                    : <ReactQuill
                        onChange={description => {
                            setProduct({...product, description})
                        }}
                        placeholder="Description"
                        value={product.description}
                    />

            }
        </Form.Item>
    );
};

export default ProductDescriptionItem;
